import {
    PATIENT_BLISTER_PACK_LIST_REQUEST,
    PATIENT_BLISTER_PACK_LIST_SUCCESS,
    PATIENT_BLISTER_PACK_LIST_FAILURE
} from "../../../constants"

import {
    patient_blister_pack,
    blister_pack_patient,
    daily_blister_pack,
    patient_bpack_onshelf,
    vials_pateint_list,
    daily_vials_pack,
    sMedication_patient_list,
    sMedication_daily_log,
    pharmacy_previous_invoice,
    get_patient_active_medication,
    pharmacy_serach_patient,
    patient_blisterack
} from "../../../../networking/urlEndPoints"

import Axios from "../../../../networking/intraceptor"
import { showToast } from "../../../../utils/helper/helper"

export const patientBlisterPackListRequest = (types) => ({
    type: PATIENT_BLISTER_PACK_LIST_REQUEST,
    types: types
})

export const patientBlisterPackListSuccess = (data, types) => ({
    type: PATIENT_BLISTER_PACK_LIST_SUCCESS,
    payload: data,
    types: types
})

export const patientBlisterPackListFailure = (error, types) => ({
    type: PATIENT_BLISTER_PACK_LIST_FAILURE,
    payload: error,
    types: types
})


export const patientActiveMedicationRequest = (types) => ({
    type: 'PATIENT_ACTIVE_MEDICATION_REQUEST',
    types: types
})

export const patientActiveMedicationSuccess = (data, types) => ({
    type: 'PATIENT_ACTIVE_MEDICATION_SUCCESS',
    payload: data,
    types: types
})

export const patientActiveMedicationFailure = (error, types) => ({
    type: 'PATIENT_ACTIVE_MEDICATION_FAILURE',
    payload: error,
    types: types
})

// -----------------------------Blister Patients list------------------------
export const fetchBlistersPatientList = (type, pageNumber, search) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const response = await Axios.get(`${patient_blister_pack}`, {
                params: {
                    page: pageNumber,
                    search: search,
                    // sortlist: 'latest'
                }
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

// -----------------------------Blister Packs list------------------------

export const fetchBlisterPacksList = (type, params, urlEndPoints) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const response = await Axios.get(`${urlEndPoints ? urlEndPoints : blister_pack_patient}`, {
                params
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

// -----------------------------Blister Daily Packs list------------------------

export const fetchBlisterDailyPackList = (type, params) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const response = await Axios.get(`${daily_blister_pack}`, {
                params
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}


// -----------------------------Blister Packs on Shelf ------------------------

export const fetchBlisterPacksOnShelfList = (type, formData, pageNumber = 1, btnType) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))

        let params = {}
        if (btnType === 'reset') {
            params = {
                page: 1,
                no_of_records: 50,
                date: formData.date
            }
        }
        else {
            params = {
                page: pageNumber,
                no_of_records: 50
            }

            if (formData.route) params.route = formData.route;
            if (formData.search) params.search = formData.search;
            if (formData.day) params.rec_day = formData.day.match(/\d+/)[0];
            if (formData.weekday) params.rec_weekday = formData.weekday;
            if (formData.facility) params.facility = formData.facility;
            // if (formData.startDate) params.from_date = formData.startDate;
            // if (formData.endDate) params.to_date = formData.endDate;
            if (formData.shelfType) params.no_of_blister_pack = formData.shelfType;
            if (formData.exclude_facility) params.exclude_facility = formData.exclude_facility;
            if (formData.date) params.date = formData.date;
            if (formData.qtyRemaining) params.qty_value = formData.qtyRemaining;
        }

        try {
            const response = await Axios.get(`${patient_bpack_onshelf}`, {
                params: params
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

export const fetchBlisterPackOnShelfPatientIDs = async (setBlisterPatientIDS) => {
    try {
        const response = await Axios.get('patient-bpack-ids');
        return setBlisterPatientIDS(response?.data?.data?.patient_blister_id || [])
    } catch (error) {
        return setBlisterPatientIDS([])
    }
}

// --------------------------------Vials Patient List----------------------------

export const fetchVialsPatientsList = (type, pageNumber, search) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const response = await Axios.get(`${vials_pateint_list}`, {
                params: {
                    page: pageNumber,
                    search: search,
                    // sortlist: 'latest'
                }
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

export const fetchVialsDailyPackList = (type, params) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            // Ensure no_of_records is always 25 for vials daily pack list
            const requestParams = {
                ...params,
                no_of_records: 25
            };
            const response = await Axios.get(`${daily_vials_pack}`, {
                params: requestParams
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

// --------------------------------Medication Patient List----------------------------

export const fetchMedicationPatientList = (type, pageNumber, search) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const response = await Axios.get(`${sMedication_patient_list}`, {
                params: {
                    page: pageNumber,
                    search: search,
                    sortlist: 'latest'
                }
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

export const fetchMEdicationDailyPackList = (type, params) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const response = await Axios.get(`${sMedication_daily_log}`, {
                params
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

// -----------------------------------Invoice Section List -------------------------

export const fetchPreviousInvoiceList = (type, params) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const response = await Axios.get(`${pharmacy_previous_invoice}`, {
                params
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}


export const fetchBlisterSheetsList = (type, payloadData) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const response = await Axios.post(`${get_patient_active_medication}`, payloadData)
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

export const fetchBlisterPatientsList = ({ setPatientList, search, pharmacyId }) => {

    return async (dispatch) => {
        try {
            setPatientList({ loading: true, data: [], error: null })
            const response = await Axios.get(`${pharmacy_serach_patient}?search=${search}`)

            if (response?.status === 200) {
                if (response?.data?.patients?.length === 1) {
                    const payloadData = {
                        phn: response?.data?.patients?.[0]?.PHN,
                        pharmacy_id: pharmacyId
                    }
                    if (response?.data?.patients?.[0]?.PHN) {
                        dispatch(fetchBlisterSheetsList('blister-sheets', payloadData))
                        setPatientList({ loading: false, data: [], error: null })
                    }
                } else {
                    setPatientList({ loading: false, data: response?.data, error: null })
                }

            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                showToast('Something went wrong when getting patient list try again', 'error')
                setPatientList({ loading: false, data: [], error: error?.response })
            }
        }
    }
}


export const fetchBlisterPackPatientList = (type, params) => {

    return async (dispatch) => {
        dispatch(patientBlisterPackListRequest(type))
        try {
            const updatedParams = { ...params, no_of_records: 50 };
            const response = await Axios.get(`${patient_blisterack}`, {
                params: updatedParams
            })
            if (response?.status === 200) {
                dispatch(patientBlisterPackListSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientBlisterPackListFailure(error?.response, type))
            }
        }
    }
}

export const fetchPatientActiveMedication = (type, payloadData) => {

    return async (dispatch) => {
        dispatch(patientActiveMedicationRequest(type))
        try {
            const response = await Axios.post(`${get_patient_active_medication}`, payloadData)
            if (response?.status === 200) {
                dispatch(patientActiveMedicationSuccess(response?.data, type))
            } else {
                throw new Error(response)
            }
        } catch (error) {
            if (error?.response) {
                dispatch(patientActiveMedicationFailure(error?.response, type))
            }
        }
    }
}